import React from 'react';

const FadeOut = () => (
  <div className="content-fade-out" />
);

export default FadeOut;



// WEBPACK FOOTER //
// ./library/app/components/Global/Misc/FadeOut.js